export default "__VITE_ASSET__DRiEQi28__"